<script>
import ReportVerification from '@/V2/documents/document-view/document-review-agent/ReportVerification.vue';
import ReportRiskHeader from '@/V2/documents/document-view/document-review-agent/ReportRiskHeader.vue';
import { mapGetters } from 'vuex';

export default {
  components: { ReportVerification, ReportRiskHeader },
  computed: {
    ...mapGetters(['getDocumentReviewAgentRunForDocId']),
    documentReviewAgentRun() {
      return this.getDocumentReviewAgentRunForDocId(
        this.$route.params.document_id,
      );
    },
  },
};
</script>

<template>
  <div
    ref="overlayContent"
    class="document-review-agent-report d-flex flex-column i-p-10 i-gap-9"
  >
    <div
      class="document-review-agent-report__header d-flex flex-column align-items-start flex-grow-1 i-gap-1"
    >
      <div class="name i-text-heading-6 i-text-neutral-120">
        Agent Summary Report
      </div>
      <div class="subtitle i-text-body-3 i-text-neutral-110">Complete</div>
    </div>
    <div class="document-review-agent-report__body d-flex flex-column i-gap-6">
      <ReportRiskHeader
        :risk-level="documentReviewAgentRun.output.risk_level"
        :confidence="documentReviewAgentRun.output.confidence"
      ></ReportRiskHeader>
      <div class="report-section analysis-summary">
        <div class="name i-text-heading-6 i-text-neutral-120">Analysis</div>
        <div
          class="i-text-body-3 i-text-neutral-120 d-flex flex-column i-gap-8"
        >
          <p
            v-for="item in documentReviewAgentRun.output.analysis_paragraphs"
            :key="item"
          >
            {{ item }}
          </p>
        </div>
      </div>
      <div class="report-section verifications">
        <div class="name i-text-heading-6 i-text-neutral-120">
          Verifications Performed
        </div>
        <div
          class="verifications-list d-flex flex-column align-items-start i-gap-9"
        >
          <div
            class="verification-item d-flex flex-column align-items-start i-gap-9"
          >
            <ReportVerification
              v-for="(verification, index) in documentReviewAgentRun.output
                .verifications"
              :key="index"
              :index="index"
              :title="verification.title"
              :result="verification.result"
              :rationale="verification.rationale"
            >
            </ReportVerification>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.document-review-agent-report {
  width: 100%;
  height: 100%;
}

.report-section {
  border: 1px solid $light-neutral-60;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 16px;
  border-radius: 16px;
}
</style>
